import React  from 'react';
import { CreateGuesser, InputGuesser } from "@api-platform/admin";
import { ReferenceInput, ReferenceArrayInput, AutocompleteInput, AutocompleteArrayInput } from 'react-admin';

const StepFormatValueCreate = (props) => (
  <CreateGuesser {...props}>
    <InputGuesser source="name" />
    <InputGuesser source="title" />
    <InputGuesser source="byDefault" />
    <InputGuesser source="color" />
    <InputGuesser source="priceSale" />
    <InputGuesser source="gelatoId" />
    <ReferenceInput
      label="Price rules"
      source="priceRules"
      reference="price_rules"
      perPage={1900}
    >
      <AutocompleteInput optionText="title" />
    </ReferenceInput>
    <ReferenceArrayInput
      label="Images"
      source="images"
      reference="files"
      perPage={10000}
    >
      <AutocompleteArrayInput
        optionText="title"
        shouldRenderSuggestions={(value) => value.trim().length >= 3}
      />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      label="Resources"
      source="resources"
      reference="files"
      perPage={10000}
      filter={{ title: "Resource format value" }}
    >
      <AutocompleteArrayInput
        optionText="title"
        shouldRenderSuggestions={(value) => value.trim().length >= 3}
      />
    </ReferenceArrayInput>
  </CreateGuesser>
  );

export default StepFormatValueCreate;